import React, { useEffect, useState } from 'react';

/**
 * Debug page to see what's in the URL when auth callback happens
 */
function AuthDebug() {
  const [info, setInfo] = useState({});

  useEffect(() => {
    const fullUrl = window.location.href;
    const hash = window.location.hash;
    const search = window.location.search;
    const pathname = window.location.pathname;

    // Parse hash parameters
    const hashParams = new URLSearchParams(hash.substring(1));
    const hashObj = {};
    for (let [key, value] of hashParams) {
      hashObj[key] = value;
    }

    // Parse search parameters
    const searchParams = new URLSearchParams(search);
    const searchObj = {};
    for (let [key, value] of searchParams) {
      searchObj[key] = value;
    }

    setInfo({
      fullUrl,
      pathname,
      hash,
      search,
      hashParams: hashObj,
      searchParams: searchObj,
    });

    console.log('Auth Debug Info:', {
      fullUrl,
      pathname,
      hash,
      search,
      hashParams: hashObj,
      searchParams: searchObj,
    });
  }, []);

  return (
    <div style={{ padding: '40px', fontFamily: 'monospace', fontSize: '14px' }}>
      <h1>Auth Debug Info</h1>

      <div style={{ marginTop: '20px' }}>
        <h3>Full URL:</h3>
        <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto' }}>
          {info.fullUrl}
        </pre>
      </div>

      <div style={{ marginTop: '20px' }}>
        <h3>Pathname:</h3>
        <pre style={{ background: '#f5f5f5', padding: '10px' }}>
          {info.pathname}
        </pre>
      </div>

      <div style={{ marginTop: '20px' }}>
        <h3>Hash:</h3>
        <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto' }}>
          {info.hash || '(empty)'}
        </pre>
      </div>

      <div style={{ marginTop: '20px' }}>
        <h3>Hash Parameters:</h3>
        <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto' }}>
          {JSON.stringify(info.hashParams, null, 2)}
        </pre>
      </div>

      <div style={{ marginTop: '20px' }}>
        <h3>Search Parameters:</h3>
        <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto' }}>
          {JSON.stringify(info.searchParams, null, 2)}
        </pre>
      </div>

      <div style={{ marginTop: '20px' }}>
        <h3>Instructions:</h3>
        <ol>
          <li>Click an email verification link</li>
          <li>Look at what URL you land on</li>
          <li>Check the console for logged info</li>
        </ol>
      </div>
    </div>
  );
}

export default AuthDebug;
